<template>
  <Minimal v-if="isMinimal" />

  <template v-else>
    <Desktop v-if="isDesktop" />
    <Mobile v-else>
      <template #top>
        <MediaRail />
      </template>
      <template #bottom>
        <ScrollyCats v-if="isScrollyCats && experiments.scrollyCatsEnabled" />
      </template>
    </Mobile>
  </template>
</template>

<script setup>
/* v8 ignore file -- @preserve */
import { computed, defineAsyncComponent } from 'vue';
import MediaRail from '~/components/header-responsive/MediaRail.bcom';
import addWindowPop from '~/utils/addWindowPop';

import { GET_IS_DESKTOP_VIEW } from '#shared/types/getters';
import Desktop from '~/components/header-desktop/Desktop.bcom';
import Mobile from '~/components/header-mobile/Mobile.common';
import ScrollyCats from '~/components/header-mobile/ScrollyCats.common';
import useExperiments from '~/composables/useExperiments';

defineProps({
  isMinimal: {
    type: Boolean,
    default: false,
  },
  isScrollyCats: {
    type: Boolean,
    default: false,
  },
});

const experiments = useExperiments();
const Minimal = defineAsyncComponent(() => import('./header-responsive/MinimalHeader.common'));

const envProps = useEnvProps();
const { hostlink } = envProps;
const navViewType = useNavViewType();
const isDesktop = computed(() => navViewType[GET_IS_DESKTOP_VIEW]);

addWindowPop(hostlink);
</script>
